import {DI_TOKENS} from '@/di/di.tokens';
import {EventEmitter} from 'pixi.js';

import {injected} from 'brandi';

export enum ClickerGameEventNames {
  // просто тап
  AnyTap = 'AnyTap',
  // любой клик, который приносит кристалы
  Tap = 'Tap',
}

export class ClickerGameEvents {
  constructor(private readonly eventEmitter: EventEmitter) {}

  public emitEvent(event: ClickerGameEventNames): void {
    this.eventEmitter.emit(event);
  }

  public subscribeOnEvent(event: ClickerGameEventNames, cb: VoidFunction): VoidFunction {
    this.eventEmitter.on(event, cb);

    return () => this.eventEmitter.off(event, cb);
  }
}

injected(ClickerGameEvents, DI_TOKENS.eventEmitter);
